<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper " style="height: 100vh">
        <v-dialog v-model="loadingTicket" persistent transition="none" width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Loading Ticket
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
        <v-card v-if="!loadingTicket" max-width="400" style="margin:auto" class="pa-4" color="bmbackground">
          <v-btn elevation="0" fab color="error" small class="modal-default-button title" @click="$emit('close')"
            :disabled="busy">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div style="clear: both"></div>
          <v-card-title v-if="ticketErrCode" class="headline text-center red--text">Ticket Error!</v-card-title>
          <div v-else class="headline text-center green--text text-xl-h6 mb-3">{{ticketObject.isVoucher?'Cash Voucher': 'Ticket Details'}}</div>
          <v-card-text v-if="ticketErrCode">
            Entered by teller: <b>{{ ticketObject.enteredid }}</b>
            <br />
            {{ ticketErrCode }}<br />
            Message: {{ ticketObject.message }}
            <br />
            Hash: {{ getTerminalId }}
            <br />
            Location: {{ getTerminalLocation }}
            <br />
            Teller: {{ username }}
          </v-card-text>
          <template v-if="hasFeature('newNavigation') && !ticketErrCode">
            <v-card-text v-if="!ticketObject.isVoucher"
              :class="$vuetify.theme.dark ? 'pa-0 pl-4 mt-1 white--text text-xl-subtitle-1' : 'pa-0 pl-4 mt-1'">
              <div class="d-flex justify-space-between mr-8 ml-4">
                <div class="font-weight-black ">Bet:</div>
                <div v-if="
                  !ticketObject.balance && ticketObject.detail &&
                  (ticketObject.detail.status !== 'cancelled' ||
                    ticketObject.detail.status !== 'fully-refunded')
                " >{{ ticketObject.detail && ticketObject.detail.id }}</div>
              </div>
              <div class="d-flex align-center justify-space-between mr-8 ml-4">
                <div class="font-weight-black ">Status:</div>
                <v-chip small label text-color="white" c
                  :color="ticketObject.balance && ticketObject.detail && ticketObject.detail.status == 'paid' ? 'success' : 'grey'">
                  {{ ticketStatusName(ticketObject.detail && ticketObject.detail.status) }}</v-chip>
              </div>
              <div class="d-flex justify-space-between mr-8 ml-4 ">
                <div class="font-weight-black ">Bet Type: </div><div >{{ betype(ticketObject.detail &&
                  ticketObject.detail.betType) }}</div>
              </div>
              <div class="d-flex justify-space-between mr-8 ml-4">
                <div class="font-weight-black">Race: </div> {{ ticketObject.detail && ticketObject.detail.raceName }} R{{
                  ticketObject.detail && ticketObject.detail.raceNumber
                }}
              </div>
              <div class="d-flex justify-space-between mr-8 ml-4">
                <div class="font-weight-black">Runner: </div>{{ ticketObject.detail &&
                  ticketObject.detail.selections.length > 0 ?
                  ticketObject.detail.selections[0].name : '' }}
              </div>
              <div v-if="ticketObject.detail && checkBranchErr(ticketObject)">
                <v-card-text class="error--text">
                  Payout exceeds payout amount! <br />
                  Must be redeemed at {{ ticketObject.masterBranch }}
                </v-card-text>
              </div>
            </v-card-text>
            <v-card-text class="headline warning--text text-center" v-if="ticketObject.isVoucher && !ticketObject.balance">
              <div >
                {{ ticketObject.ticketId }}
              </div>
              <div class="mt-2">
                Previously Redeemed
              </div>
            </v-card-text>
          </template>
          <v-card-text class="headline" v-if="ticketObject.paid && !ticketObject.balance">
            Paid: ${{ ticketObject.paid }}
          </v-card-text>
          <v-card-text class="headline warning--text text-center" v-if="ticketObject.balance">
            Owed: ${{ ticketObject.balance }}
          </v-card-text>
          <v-card-text class="headline error--text"
            v-if="ticketObject.detail && ticketObject.detail.status === 'cancelled'">
            CANCELLED BET
          </v-card-text>
          <v-card-text class="headline error--text"
            v-if="ticketObject.detail && ticketObject.detail.status === 'fully-refunded'">
            SCRATCHED / ABANDONED
          </v-card-text>
          <div v-if="checkBranchEnabled(ticketObject)">
            <div v-if="ticketObject.balance && !checkBranchErr(ticketObject)" class="d-flex flex-column">
              <v-btn elevation="0" v-if="!disablePayout" x-large @click="
                RedeemTicket(
                  ticketObject.balance,
                  ticketId,
                  ticketObject.isVoucher? '':ticketObject.detail.status,
                  ticketObject.version
                )
              " color="success" :disabled="busy">
                <span class="display-1">{{
                  ticketObject.detail && ticketObject.detail.status === "fully-refunded"
                  ? "refund"
                  : "payout"
                }}
                  ${{ ticketObject.balance }}</span>
              </v-btn>
              <v-btn elevation="0" v-if="showScanMore && !disablePayout" x-large class="mt-2" color="warning"
                @click="enterMultiRedemptionMode()" :disabled="busy">
                <span>{{
                  ticketObject.detail.status === "fully-refunded"
                  ? "refund"
                  : "payout"
                }}
                  and <br />
                  scan more</span>
              </v-btn>
            </div>
            <div v-else>
              <v-btn elevation="0" v-if="
                reprintOn &&
                !ticketErrCode &&
                ticketObject && ticketObject.detail &&
                checkStatus(ticketObject.detail.status)
              " x-large class="scannedTicketButton mb-5" @click="onReprintClick()" color="warning">
                <span class="display-1">Re-Print</span>
              </v-btn>
              <v-btn elevation="0" v-if="showScanMore" x-large class="scannedTicketButton mb-5" color="warning"
                @click="enterMultiRedemptionMode()" :disabled="busy">
                <span class="display-1">scan more</span>
              </v-btn>
              <v-btn elevation="0" v-if="ticketObject.detail &&
                ticketObject.detail.status === 'unresulted' &&
                !ticketObject.balance
              " x-large class="scannedTicketButton" @click="refundDialog = true" color="disabled">
                <span class="display-1">{{ refundName("Refund") }}</span>
              </v-btn>
            </div>
          </div>
          <div v-else>
            <div v-if="ticketObject.balance" class="d-flex flex-column">
              <v-btn elevation="0" x-large v-if="!disablePayout" @click="
                RedeemTicket(
                  ticketObject.balance,
                  ticketId,
                  ticketObject.isVoucher? '': ticketObject.detail.status,
                  ticketObject.version
                )
              " color="success" :disabled="busy">
                <span class="display-1">{{
                  ticketObject.detail && ticketObject.detail.status === "fully-refunded"
                  ? "refund"
                  : "payout"
                }}
                  ${{ ticketObject.balance }}</span>
              </v-btn>
              <v-btn elevation="0" v-if="showScanMore && !disablePayout" x-large class="mt-2" color="warning"
                @click="enterMultiRedemptionMode()" :disabled="busy">
                <span>{{
                  ticketObject.detail && ticketObject.detail.status === "fully-refunded"
                  ? "refund"
                  : "payout"
                }}
                  and <br />
                  scan more</span>
              </v-btn>
            </div>
            <div v-else>
              <v-btn elevation="0" v-if="
                reprintOn &&
                !ticketErrCode &&
                ticketObject && ticketObject.detail &&
                checkStatus(ticketObject.detail.status)
              " x-large class="scannedTicketButton mb-5" @click="onReprintClick()" color="warning">
                <span class="display-1">Re-Print</span>
              </v-btn>
              <v-btn elevation="0" v-if="showScanMore" x-large class="scannedTicketButton mb-5" color="warning"
                @click="enterMultiRedemptionMode()" :disabled="busy">
                <span class="display-1">scan more</span>
              </v-btn>
              <v-btn elevation="0" v-if="ticketObject.detail &&
                ticketObject.detail.status === 'unresulted' &&
                !ticketObject.balance
              " x-large class="scannedTicketButton" @click="refundDialog = true" color="disabled">
                <span class="display-1">{{ refundName("Refund") }}</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
      <v-row justify="center">
        <v-dialog v-model="refundDialog" persistent max-width="400">
          <v-card>
            <v-card-title class="text-h5 warning--text">
              {{ refundName("Refund") }}
            </v-card-title>
            <v-card-text v-for="details in ticketObject.details" :key="details.id">
              <strong>Bet:</strong> {{ details.id }}
              <span v-if="!ticketObject.balance"><br /><strong>Status:</strong>
                {{ ticketStatusName(details.status) }}</span>
              <br /><strong>Bet Type:</strong> <br /><strong>Race:</strong>
              {{ details.raceName }} R{{ details.raceNumber }} <br /><strong>Runner:</strong>
              {{ details.runnerName }}
              <br />
              <v-card-text class="title pl-0">Confirm refund of
                <span class="success--text headline">${{ details.stake }}</span></v-card-text>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn elevation="0" x-large color="warning" @click="refundTicket(ticketObject)">
                Confirm
              </v-btn>
              <v-btn elevation="0" x-large color="error" @click="refundDialog = false">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <UserRoleValidationModal :successCallback="reprintTicket" ref="rolevalidation" />
    </div>
  </transition>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { Auth } from "aws-amplify";
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  MULTIREDEMPTIONAVAILABLE,
  REPRINTAVAILABLE,
  USERROLE,
} from "../common/constants";
import {
  generateBrandImage,
  generateCustomerBetReceipt,
  generatePayoutReceipt,
  generateTellerRefundReceipt,
} from "../common/tickets";
import {
  getTicketStatusName,
  getBetTypeName,
  getRefundName,
} from "../common/methods";
import UserRoleValidationModal from "./UserRoleValidationModal.vue";
export default {
  data() {
    return {
      busy: false,
      refundDialog: false,
      username: "",
    };
  },
  props: {
    ticketErrCode: Error,
    ticketObject: Object,
    ticketId: String,
    failedTicketCash: Function,
    enterMultiRedemptionMode: Function,
    hideScanMore: Boolean,
    loadingTicket: Boolean,
    successfulTrans: Function,
    isReaderScan: Boolean // ticket scanned from rt reader
  },
  computed: {
    ...mapGetters([
      "getTerminalId",
      "getTerminalBranch",
      "hasFeature",
      "getVenueName",
      "getTerminalLocation",
      "getTerminalId",
      "getMultiRedemptionMode",
      "getLastAuthUserRole",
    ]),
    details() {
      return this.ticketObject?.detail;
    },
    reprintOn() {
      const venue = this.getVenueName;
      if (REPRINTAVAILABLE[venue]) return true;
      return false;
    },
    multiRedemtionOn() {
      const venue = this.getVenueName;
      return MULTIREDEMPTIONAVAILABLE[venue];
    },
    showScanMore() {
      return (
        this.multiRedemtionOn &&
        !this.getMultiRedemptionMode &&
        this.hasFeature("multiRedemption") &&
        !this.ticketErrCode && !this.hideScanMore
      );
    },
    disablePayout() {
      return this.hideScanMore;
    },
  },
  watch: {
    ticketErrCode() {
      this.getUserName();
    },
  },
  methods: {
    ...mapActions(["setProcessedBet", "getTerminalToken"]),
    ...mapMutations(["setPrintedBets"]),
    async getUserName() {
      const result = await Auth.currentUserInfo();
      this.username = result.username;
    },
    checkBranchEnabled(ticket) {
      const capSet = ticket.branchCapEnabled;
      const branch = this.getTerminalBranch;
      if (capSet && this.hasFeature("cappedTickets") && branch !== "")
        return true;
      return false;
    },
    checkBranchErr(ticket) {
      const branch = ticket.masterBranch;
      const cap = ticket.branchCap;
      const payout = ticket.balance;
      const capSet = ticket.branchCapEnabled;
      if (
        branch !== this.getTerminalBranch &&
        payout > cap &&
        capSet &&
        this.hasFeature("cappedTickets")
      )
        return true;
      return false;
    },
    checkStatus(v) {
      if (v === "cancelled") return false;
      if (v === "paid") return false;
      return true;
    },
    refundName(v) {
      return getRefundName(v, this.getVenueName);
    },
    betype(v) {
      return getBetTypeName(v, this.getVenueName);
    },
    ticketStatusName(v) {
      return getTicketStatusName(v, this.ticketObject, this.getVenueName);
    },
    async onReprintClick() {
      if (this.getLastAuthUserRole == USERROLE.ENDUSER) {
        this.$refs.rolevalidation.open(
          "",
          "Please enter admin's credential to authorise for re-print the ticket",
          { zIndex: 9999 }
        );
      } else {

        this.reprintTicket();
      }
    },
    async reprintTicket() {
      const token = await this.getTerminalToken()
      await axios
        .post(
          `${process.env.VUE_APP_LEDGER_ENDPOINT}public/ReissueTicket`,
          {
            terminal_id: token,
            ticket_id: this.ticketId,
            version: this.ticketObject.version
          }
        )
        .then((result) => {
          this.printThisTicket(null, result.data);
        })
        .catch((error) => {
          console.log(error);
          this.$refs.rolevalidation.close();
        });
    },

    //Note: if any logic changes for win ticket, please also consider if need a change in method "printWinTicketInmultiRedemptionMode"
    printThisTicket(payout, reprint, refund, timestamp) {
      if (this.ticketObject.isVoucher) {
        this.$emit("close")// skip if it's voucher
      }
      const details = this.ticketObject.detail;
      const bet = {
        id: details.id,
        selId: details.selections[0]?.id,
        runnerNumber: details.selections[0]?.number,
        runnerName: details.selections[0]?.name,
        raceName: details.meetingName,
        trackName: details.raceName,
        trackNumber: details.raceNumber,
        stake: details.stake,
        startTime: undefined, // FIXME
        status: details.status,
        ticketId: this.ticketId,
        time: timestamp,
        trackCountry: "",
        winPlc: details.betType,
        odds:  parseFloat(details.odds /100) || 0,
        reprint: reprint,
        printed: true,
        key: details.id,
        payout: payout,
        refundOwing: refund,
      };
      this.setPrintedBets(bet);
      const playerId = null;
      if (window.rt?.printImage) {
        if (!payout && !refund && !reprint) {
          window.rt
            .printImage(
              generateCustomerBetReceipt(
                bet,
                this.getTerminalLocation,
                playerId,
                this.$route.query.venue
              )
            )
            .then(() => this.$emit("close"))
            .catch((e) => console.log(`Failed to print: ${e}`));
        } else if (reprint) {
          window.rt
            .printImage(
              generateCustomerBetReceipt(
                bet,
                this.getTerminalLocation,
                playerId,
                this.$route.query.venue
              )
            )
            .then(() => this.$emit("close"))
            .catch((e) => {
              console.log(`Failed to print: ${e}`);
              this.printing = false;
            });
        } else if (!payout && refund) {
          window.rt
            .printImage(
              generateTellerRefundReceipt(
                bet,
                this.getTerminalLocation,
                playerId,
                this.$route.query.venue
              )
            )
            .then(() => this.$emit("close"))
            .catch((e) => {
              console.log(`Failed to print: ${e}`);
              this.printing = false;
            });
        } else {
          window.rt
            .printImage(
              generatePayoutReceipt(
                bet,
                this.getTerminalLocation,
                this.$route.query.venue
              )
            )
            .then(() => this.$emit("close"))
            .catch((e) => console.log(`Failed to print: ${e}`));
        }
      } else {
        Vue.nextTick(() => {
          // this.updateBet(updatedBet, updatedBets)()
          window.onafterprint = this.$emit("close");
          window.print();
        });
      }
    },
    async refundTicket(ticket) {
      if (this.busy) {
        return;
      } else {
        this.busy = true;
      }
      const token = await this.getTerminalToken()
      const userName = this.username
      await axios
        .post(
          `${process.env.VUE_APP_LEDGER_ENDPOINT}public/CancelBetAttendant`,
          {
            terminal_id: token,
            ticket_id: this.ticketId,
          }
        )
        .then( async (res)  => {
          console.log(res);
          if (res.data.success) {
            const time = res.data.timestamp;
            this.busy = false;
            // this.successfulTicketCash(stake, "refund");
            if(this.isReaderScan){
             await window.rt?.brandImageBackward(generateBrandImage('REFUNDED', ticket.detail.stake, userName))
             window.rt?.eject()
            }   
            this.printThisTicket(null, false, ticket.detail.stake, time);
          } else {
            this.busy = false;
            this.failedTicketCash(res.data.error);
            this.$emit("close");
          }

        })
        .catch((e) => {
          if (e.response.data.message) {
            console.log(e.response.data.message);
            this.busy = false;
            this.failedTicketCash(e.response.data.message);
            this.$emit("close");
          } else {
            this.busy = false;
            this.failedTicketCash("Error Unknown - Cannot Process Refund");
            this.$emit("close");
          }
        });
    },
    async RedeemTicket(transAmt, ticketId, status, ticketVersion) {
      if (this.busy) {
        return;
      } else {
        this.busy = true;
      }
      if (status === "fully-refunded") {
        const token = await this.getTerminalToken()
        const userName = this.username
        await axios
          .post(
            `${process.env.VUE_APP_LEDGER_ENDPOINT}public/RedeemTicket`,
            {
              terminal_token: token,
              amount: transAmt,
              //type: 1, // REFUND
              ticket_id: ticketId,
              //reason: `${ticketId} 'Scratched / Abandoned'`,
              version: ticketVersion
            }
          )
          .then(async () => {
            console.log("payout processed");
            this.busy = false;
            if(this.isReaderScan){
              await window.rt?.brandImageBackward(generateBrandImage('REFUNDED', transAmt, userName))
             window.rt?.eject()
            }
            this.successfulTrans();  
          })
          .catch((e) => {
            console.log("payout not processed");
            console.log(e.message);
            this.busy = false;
            this.failedTicketCash();
            this.$emit("close");
          });
      } else {
        const token = await this.getTerminalToken()
          await axios
          .post(
            `${process.env.VUE_APP_LEDGER_ENDPOINT}public/RedeemTicket`,
            {
              amount: transAmt,
              //type: 0, // BETPAID
              ticket_id: ticketId,
              terminal_token: token,
              version: ticketVersion
            }
          )
          .then(async () => {
            console.log("payout processed", this.isReaderScan);
            this.busy = false;
            if(this.isReaderScan){
             await window.rt?.brandImageBackward(generateBrandImage('CASHED', transAmt, this.username))
             window.rt?.eject()
            }
            if (!this.ticketObject.isVoucher) {
              this.printThisTicket(transAmt, false)
            }
            this.successfulTrans();
          })
          .catch((e) => {
            console.log("payout not processed");
            console.log(e.message);
            this.busy = false;
            this.failedTicketCash();
            this.$emit("close");
          });
      }
    },
  },
  components: {
    UserRoleValidationModal,
  },
};
</script>

<style>
.scannedTicketButton {
  border-radius: 8px;
  width: 100%;
  padding: 12px;
  color: #fff;
  font-size: 1.8em;
  text-align: center;
  bottom: -50px;
  z-index: 200;
  position: relative;
  font-weight: 600;
  cursor: pointer;
}</style>
